import { UNOAPP_PAYMENTS_API_TOKEN, UNOAPP_PAYMENTS_API_URL } from './env.js'
import { Fetch } from './fetch'

const _fetch = new Fetch({ baseURL: UNOAPP_PAYMENTS_API_URL, headers: { 'api-token': UNOAPP_PAYMENTS_API_TOKEN } })

export const PAYMENTS_API = {
  PaymentMethods: {
    /**
     * Make a call to payments api to add payment method to existing customer
     * @param {body}
     * @returns {Promise}
     */
    AddPaymentMethodToCustomer (body) {
      return _fetch.post({
        url: '/api/v1/payment_methods',
        body
      })
    }
  },
  Transactions: {
    /**
     * Make a call to payments api to add payment method to existing customer
     * @param {body}
     * @returns {Promise}
     */
    processTransactionUsingExistingCard (body) {
      return _fetch.post({
        url: '/api/v1/transactions/pay',
        body
      })
    }
  }
}
